import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { Redirect } from 'react-router-dom';
import RaisedButton from 'material-ui/RaisedButton';
import Popover from 'material-ui/Popover';
import Menu from 'material-ui/Menu';
import MenuItem from 'material-ui/MenuItem';
import DeleteDialog from '../../../portal/dialogs/deleteDialog';
import ErrorDialog from '../../../portal/dialogs/errorDialog';
import ToastrLevelsEnum from '../../../../services/enums/toastrLevelsEnum';
import ToastrService from '../../../../services/ui/toastrService';

@inject('rolesStore', 'translationsStore') @observer
export default class ContextMenu extends Component {
    
    state = {
        openContextMenu: false,
        openDeleteDialog: false,
        showErrorDialog: false,
        goToEditRoleScreen: false,
        goToDuplicateRoleScreen: false,
    };

    openEditMenu = event => {

        event.preventDefault();
    
        this.setState({
            openContextMenu: true,
            anchorEl: event.currentTarget
        });
    };

    handleRequestClose = () => {
        
        this.setState({
            openContextMenu: false
        });
    };
    
    openDeleteDialog = () => {

        this.closeAll();
        this.setState({ 
            openDeleteDialog: true
        }); 
    }

    closeAll = () => {

        this.setState({
            openDeleteDialog: false,
            openContextMenu: false
        }); 
    }

    handleDeleteDialogConfirm = () => {

        this.props.rolesStore.deleteRole(this.props.id).then(() => {

            this.closeDeleteDialog();
            this.props.rolesStore.getAllRoles();

            const level = ToastrLevelsEnum.SUCCESS;
            const message = this.props.translations.rolesDeletedSuccessMessage;
            this.triggerToastr(message, level);
        })
        .catch(() => {

            this.closeDeleteDialog();
            this.openErrorDialog();
        });
    }

    closeDeleteDialog = () => {

        this.setState({ 
            openDeleteDialog: false
        }); 
    }

    triggerToastr = (message, level) => {

        ToastrService.triggerToastr({level, message});
    }

    openErrorDialog = () => {

        this.setState({ 
            showErrorDialog: true
        }); 
    }

    closeErrorDialog = () => {

        this.setState({ 
            showErrorDialog: false
        }); 
    }

    goToEditRoleScreen = _ => {

        this.props.rolesStore.setEditRole();

        this.setState({
            goToEditRoleScreen: true
        });
    }

    goToDuplicateRoleScreen = _ => {

        this.props.rolesStore.setEditRole();
        
        this.props.rolesStore.getRole(this.props.id)
            .then(role => {

                const duplicatedRole = 
                {
                    name: this.formatDuplicatedRoleName(role.name),
                    description: role.description,
                    permissionIds: role.permissionIds
                };
                
                this.props.rolesStore.setEditRole(duplicatedRole);
                this.props.rolesStore.setName(duplicatedRole.name);
                this.props.rolesStore.setDescription(duplicatedRole.description);
                this.props.rolesStore.setPermissionIds(duplicatedRole.permissionIds);

                this.setState({
                    goToDuplicateRoleScreen: true
                });
            });
    }

    formatDuplicatedRoleName = (roleName) => {  
        return this.props.translationsStore.translate('COPY_OF_DATA')
                            .replace('{data}', roleName);
    }

    render() {
        
        if(this.state.goToEditRoleScreen === true) {
            
            return <Redirect to={`/roles/${this.props.id}`} />;
        }

        if(this.state.goToDuplicateRoleScreen === true) {
            
            return <Redirect to={'/roles/0'} />;
        }

        return (
            <div>
                <RaisedButton
                    onClick={this.openEditMenu}
                    className='grid-context-menu-button'
                    data-cy='edit-user-menu-icon-button'
                    buttonStyle={{
                        width: '16px'
                    }}
                    icon={<span className='menu-icon icon-button'></span>}
                />
                <Popover
                    className='edit-context-menu'
                    style={{
                        fontSize: '15px'
                    }}
                    open={this.state.openContextMenu}
                    anchorEl={this.state.anchorEl}
                    anchorOrigin={{horizontal: 'right', vertical: 'bottom'}}
                    targetOrigin={{horizontal: 'right', vertical: 'top'}}
                    onRequestClose={this.handleRequestClose}
                >
                    <Menu>
                        <MenuItem  
                            primaryText={this.props.translations.edit}
                            onClick={this.goToEditRoleScreen}
                            data-cy='edit-role-action'
                        />
                        <MenuItem
                            onClick={this.goToDuplicateRoleScreen}
                            primaryText={this.props.translations.duplicate}
                            data-cy='duplicate-role-action'
                        />
                        <MenuItem
                            onClick={this.openDeleteDialog}
                            primaryText={this.props.translations.delete}
                            data-cy='delete-role-action'
                        />
                    </Menu>
                </Popover>
                <DeleteDialog 
                    show={this.state.openDeleteDialog}
                    onConfirm={this.handleDeleteDialogConfirm}
                    closeDeleteDialog={this.closeDeleteDialog}
                    titleText={this.props.translations.deleteRole}
                    contentText={this.props.translations.deleteRoleConfirm
                                                             .replace('{roleName}', this.props.data.name)}
                    inProgress={this.props.rolesStore.deletingRoleInProgress}
                    deleteButtonText={this.props.translations.deleteButtonText}
                    cancelText={this.props.translations.cancelText}                           
                />
                <ErrorDialog 
                    show={this.state.showErrorDialog}
                    onConfirm={this.closeErrorDialog}
                    deleteButtonText={this.props.translations.close}
                    closeDeleteDialog={this.closeErrorDialog}
                    titleText={this.props.translations.error}
                    contentText={this.props.rolesStore.deleteRoleErrorMessage}
                />
            </div>
        );
  }
}
